import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  get queryInput() {
    if (this.hasInputTarget) return this.inputTarget
    return this.element.querySelector('[data-filter-target="input"], input[type="text"], input.form-control')
  }

  get filterItems() {
    const explicitItems = Array.from(
      this.element.querySelectorAll('[data-filter-target~="item"], [data-target="filter.item"]')
    )
    if (explicitItems.length > 0) return explicitItems

    return Array.from(this.element.querySelectorAll(".list-group-item")).filter(
      item => item.querySelector("a, button, .search-text")
    )
  }

  connect() {
    this.boundUpdate = this.update.bind(this)
    let savedQuery = ""
    try {
      savedQuery = localStorage.getItem("searchQuery") || ""
    } catch (_e) {
      savedQuery = ""
    }
    if (savedQuery && this.queryInput) this.queryInput.value = savedQuery

    if (this.queryInput) {
      this.queryInput.addEventListener("input", this.boundUpdate)
    }

    this.globalCheckbox = document.getElementById("toggle-global-extents")
    this.update()
  }

  disconnect() {
    if (this.queryInput && this.boundUpdate) {
      this.queryInput.removeEventListener("input", this.boundUpdate)
    }
  }

  update(event) {
    const query = this.queryInput ? this.queryInput.value.toLowerCase() : ""

    if (this.queryInput) {
      try {
        localStorage.setItem("searchQuery", query)
      } catch (_e) {
        // Ignore storage failures (e.g. private mode / quota).
      }
    }

    const showGlobal = this.globalCheckbox ? this.globalCheckbox.checked : true
    const items = this.filterItems

    items.forEach(target => {
      const searchElem = target.querySelector('.search-text');
      const fallbackText = target.innerText || ''
      const extra = (target.getAttribute('data-search-extra') || '').toLowerCase()
      const searchText = `${searchElem ? searchElem.innerText.toLowerCase() : fallbackText.toLowerCase()} ${extra}`.trim()
      const isGlobal = target.getAttribute('data-global') === 'true';

      const searchTerms = query.split(" ")
      const matchesSearch = searchTerms.every(term => searchText.includes(term))
      const matchesGlobal = showGlobal || !isGlobal

      if (!target.dataset.filterDisplay) {
        target.dataset.filterDisplay = window.getComputedStyle(target).display || "block"
      }

      if (matchesSearch && matchesGlobal) {
        target.style.display = target.dataset.filterDisplay === "none" ? "" : target.dataset.filterDisplay
      } else {
        target.style.display = "none"
      }
    });
  }

  toggleGlobal() {
    this.update()
  }
}
